import { Injectable } from '@angular/core';
import { ModelFacadeInterface, ModelStore } from '@web-portal/domains/shared/domain-models';

@Injectable()
export class ModelFacade implements ModelFacadeInterface {
  private readonly modelStore = new ModelStore();

  readonly models = this.modelStore.models;
  /** Maximum 4 recent models sorted by changed/created date (newest first) */
  readonly recentModels = this.modelStore.recentModels;
}
